/**
 * MAHI's thinking/typing indicator — the spec is explicit that this must
 * never be a generic spinner, and must read as "the same entity, still
 * thinking" as the orb. `MahiRobot`'s own `thinking` mood glows amber
 * (rgba(250,204,21,...)), which is the app's alert/loading language
 * elsewhere, not hers — so rather than reuse that mood, this is built
 * straight from the orb's own blur-glow-pulse (bg-mahiteal-400, blur(9px),
 * opacity/scale keyframes), just smaller, so the two visually rhyme.
 */
import React from 'react';
import { motion } from 'framer-motion';
import useReducedMotion from '../../hooks/useReducedMotion';

export default function MahiThinkingIndicator({ label }) {
  const reduced = useReducedMotion();

  return (
    <div className="flex items-center gap-2.5 py-1" data-testid="mahi-thinking">
      <span className="relative w-5 h-5 shrink-0" aria-hidden="true">
        <motion.span
          className="absolute inset-0 rounded-full bg-mahiteal-400"
          style={{ filter: 'blur(4px)' }}
          animate={reduced ? { opacity: 0.45 } : { opacity: [0.3, 0.75, 0.3], scale: [0.85, 1.08, 0.85] }}
          transition={reduced ? { duration: 0 } : { duration: 1.2, repeat: Infinity, ease: 'easeInOut' }}
        />
        <span className="absolute inset-[4px] rounded-full bg-mahiteal-500" />
      </span>
      {label && (
        <span className="text-[13px] text-mahiteal-700 font-mahi-sans" data-testid="mahi-thinking-label">
          {label}
        </span>
      )}
    </div>
  );
}
